import { useSelector } from 'react-redux';

export const useIsInSplitTestGroup = (splitTest, groupName) =>
    useSelector((state) => state.environment.splitTestGroups[splitTest]) ===
    groupName;
